import { render } from "./SocialMediaEditView.vue?vue&type=template&id=26aa4160"
import script from "./SocialMediaEditView.vue?vue&type=script&lang=js"
export * from "./SocialMediaEditView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__